import { action } from 'typesafe-actions';
import { RouterProps } from 'react-router';

import { INewsForm } from 'NewsPackage/FormModule/interfaces/INewsForm';

import { NewsFormActionsEnum } from '../enums/NewsFormActionsEnum';
import { INewsFile } from '../interfaces/INewsFile';

export const newsFormSetNewsId = (newsId?: string) => action(NewsFormActionsEnum.NEWS_FORM_SET_NEWS_ID, { newsId });
export const newsFormAdd = (values: INewsForm, history?: RouterProps['history'], files?: INewsFile[]) =>
  action(NewsFormActionsEnum.NEWS_FORM_ADD, { values, files, history });
export const newsFormGetSingleNews = (newsFormId?: string) =>
  action(NewsFormActionsEnum.NEWS_FORM_GET_SINGLE_NEWS, { newsFormId });
export const newsFormSetSingleNews = (singleNews?: INewsForm) =>
  action(NewsFormActionsEnum.NEWS_FORM_SET_SINGLE_NEWS, { singleNews });
export const newsFormUpdate = (values: INewsForm, deletedFiles?: number[], files?: INewsFile[]) =>
  action(NewsFormActionsEnum.NEWS_FORM_UPDATE, { values, deletedFiles, files });
